import type { ComponentProps } from "react";

import { cx, styled } from "simplydo/react/styled";
import { Icon } from "simplydo/react/ui/icon";
import { Label } from "simplydo/react/ui/label";
import type { UiColor } from "simplydo/react/ui/utils/colors";

const SelectIdeaChipStyled = styled.div<{ $compact?: boolean }>`
  display: flex;
  width: ${({ $compact }) => ($compact ? "25px" : "35px")};
  height: ${({ $compact }) => ($compact ? "40px" : "55px")};
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background-color: #e9ebee;
  color: gray;
  cursor: pointer;
  &.is-selected {
    background-color: ${({ theme }) => theme.primaryColour};
    color: #fff;
  }
  > ${Icon} {
    width: 1em;
    margin-right: 0;
    margin-top: ${({ $compact }) => ($compact ? "0 !important" : "7px")};
  }
  &:not(.is-selected) > ${Icon} {
    opacity: 0;
  }
  &:hover {
    > ${Icon} {
      opacity: 1;
    }
  }
`;

type SelectIdeaChipProps = ComponentProps<typeof SelectIdeaChipStyled> & {
  $isSelected?: boolean;
};

const SelectIdeaChip = ({
  $isSelected,
  className,
  ...props
}: SelectIdeaChipProps) => (
  <SelectIdeaChipStyled
    className={cx($isSelected && "is-selected", className)}
    {...props}
  />
);

const IdeaCoverImage = styled.div<{ $coverImage: string }>`
  display: flex;
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-image: ${({ $coverImage }) => `url(${$coverImage})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  cursor: pointer;
  &:hover {
    box-shadow: inset 0 0 0 2000px rgba(211, 211, 211, 0.3);
  }
`;

type StatusLabelProps = {
  style?: React.CSSProperties;
  color?: UiColor;
  children?: React.ReactNode;
};

const StatusLabel = ({ style, ...props }: StatusLabelProps) => (
  <Label
    size="small"
    {...props}
    style={{ ...style, marginRight: 5 }}
    circular
  />
);

const IdeaUpdateStatus = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-left: 2px;
  span {
    color: black;
  }
  a {
    text-decoration: underline;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ui.label,
  i.icon {
    width: 1.3em !important;
    height: 1.3em !important;
    margin-bottom: 1.5px;
  }
`;

export { SelectIdeaChip, IdeaCoverImage, StatusLabel, IdeaUpdateStatus };
